import React, { Component } from "react";
import Helping from "../../helpers/Helping";
import Service from "../../helpers/service";
import { update } from "../../services/cms_pages.service";
import { setErrorFields, validateField, clearErrorFields } from "../../helpers/validationHelpers";
import Notification from "../layout/Notification";
import { addCurrentRoute } from '../../actions/profile_action';
import { connect } from 'react-redux';
import { MESSAGE } from '../../config/index';
import { GET_CMS_PAGE, CMS_PAGES, CMS_SECTION_DETAIL } from '../../config/routes';
import LoadingButton from '../fields/LoadingButton';
import { Progress } from 'react-sweet-progress';
import { API_URL } from '../../config/urls';
import Modal from "../layout/Modal";
import { Link } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import Editor from "../layout/Editor";
import $ from 'jquery';

const { NOT_FOUND, UPDATE, CREATE, EMPTY, DELETE } = MESSAGE;

class Detail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: '',
            modalTitle: 'Add New Section',
            btnTitle: 'Save',
            page: {},
            sections: [],
            currentSection: {},
            title: '',
            code: '',
            status: 'PUBLISHED',
            is_live: false,
            prefix: "",
            backgroundImage: "",
            page_id: "",
            section_id: "",
            routeName: '',
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsEnable: false
        };

        this.handleSectionValueChange = this.handleSectionValueChange.bind(this);
        this.onSectionUpdate = this.onSectionUpdate.bind(this);
        this.onSectionCreate = this.onSectionCreate.bind(this);
        this.onPageUpdate = this.onPageUpdate.bind(this);
        this.deleteSection = this.deleteSection.bind(this);
    }

    handleChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === 'title')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'code')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'status')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
        if (name === 'prefix')
            this.setState({ ...(await validateField('string', name, value, '', 1)) });
    }

    async handleSectionValueChange(e, type) {
        let { name, value } = e.target;

        if (name === "isActive" || name === "isLoop")
            value = e.target.checked;

        let validation = validateField(type, name, value).then(errorObject => {

            this.setState({
                currentSection: {
                    ...this.state.currentSection,
                    ...errorObject,
                }
            });
        })

        this.setState({
            currentSection: { ...this.state.currentSection, [name]: value }
        });
    }

    handleFileUpload = async (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            var t = file.type.split('/').pop().toLowerCase();

            if (t != "jpeg" && t != "jpg" && t != "png" && t != "bmp" && t != "gif") {

                this.setState((previousState) => {
                    let currentContent = previousState.currentSection;
                    currentContent[`error_${name}_message`] = "Please select a valid image file";
                    return previousState;
                })
                return false;
            }
            else {
                const response = await Helping.signFile("cms/sections/", file, "image", (res) => {

                    if (res.imagePercent) {
                        this.setState((previousState) => {
                            let currentContent = previousState.currentSection;
                            currentContent[`${name}Percent`] = res.imagePercent;
                            return previousState;
                        })
                    }
                });

                this.setState((previousState) => {
                    let currentContent = previousState.currentSection;
                    currentContent[name] = response.image;
                    currentContent[`error_${name}_message`] = "";
                    return previousState;
                })
            }
        }
    }

    removeSectionImage = (name, id) => {
        $(`#${id}`).val('');

        this.setState((previousState) => {
            let currentContent = previousState.currentSection;
            currentContent[name] = "";
            currentContent[`${name}Percent`] = 0;
            return previousState;
        })
    }

    removePageImage = (name, id) => {
        $(`#${id}`).val('');

        this.setState({ [name]: "", [`${name}Percent`]: 0 });
    }

    handleImageUpload = async (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            var t = file.type.split('/').pop().toLowerCase();

            if (t != "jpeg" && t != "jpg" && t != "png" && t != "bmp" && t != "gif") {
                this.setState({ ...this.state, [`error_${name}_message`]: "Please select a valid image file" })
                return false;
            }
            else {
                const response = await Helping.signFile("cms/pages/", file, "image", (res) => {
                    if (res.imagePercent) this.setState({ ...this.state, [`${name}Percent`]: res.imagePercent });
                });
                this.setState({ ...this.state, [name]: response.image, [`error_${name}_message`]: "" });
            }
        }
    }

    handleAddSection = (e) => {
        e.preventDefault();

        this.setState((previousState) => {
            let currentSection = previousState.currentSection;
            currentSection.title = "";
            currentSection.heading = "";
            currentSection.content = "";
            currentSection.type = "";
            currentSection.isActive = true;
            currentSection.isLoop = false;
            currentSection.orderSequence = "";
            currentSection.logoUrl = "";
            currentSection.image = "";
            currentSection.mobileImage = "";
            currentSection.buttonTitle = "";
            currentSection.link = "";
            currentSection.defaultBtnTitle = "";
            currentSection.defaultBtnLink = "";

            previousState.modalTitle = 'Add New Section';
            previousState.btnTitle = 'Save';
            return previousState;
        })
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    componentDidMount() {
        var self = this;
        if (this.props.match.params.id) {

            self.setState({
                url: API_URL.ADMIN_API + GET_CMS_PAGE
            }, function () {
                self.getById();
                this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);
            });
        }
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    getById = () => {
        var $this = this;

        let data = {
            action: "get-page-info-by-id",
            id: this.props.match.params.id
        }

        trackPromise(
            Service.postCall(this.state.url, data)
                .then((response) => {
                    var page = response.data.payload;
                    var sections = page.cms_page_sections;

                    $this.setState({
                        page_id: this.props.match.params.id,
                        page: page,
                        sections: sections,
                        title: page.menuTitle,
                        code: page.menuCode,
                        status: page.status,
                        is_live: page.isLive,
                        prefix: page.prefix,
                        backgroundImage: page.backgroundImage,
                        isLoading: false,
                    });
                })
                .catch((error) => {
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return $this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            isLoading: false,
                        });
                    }
                    return this.setState({
                        isLoading: false,
                        ...Helping.setNetworkRequestError(error, 'fetching cms page'),
                    });
                })
        )
    }

    openEditModal = (e, object) => {
        this.setState({
            currentSection: {
                ...object,
                defaultBtnTitle: object.defaultBtnTitle ? object.defaultBtnTitle : "",
                defaultBtnLink: object.defaultBtnLink ? object.defaultBtnLink : ""
            },
            section_id: object.id,
            modalTitle: 'Edit Page Section',
            btnTitle: 'Update'
        })
    }

    closeModal = () => {
        this.setState({
            section_id: ""
        })
        window.$('#editPage').modal('hide');
        window.$('#editSection').modal('hide');
        window.$('#exampleDeleteModal').modal('hide');
    }

    openConfirmationModal = (e, object) => {
        this.setState({ section_id: object.id });
    }

    checkPageEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.title != null && state.title.length < 1) {
            let errorObject = setErrorFields(
                'title',
                Helping.getMessageString(EMPTY, 'Title')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.code != null && state.code.length < 1) {
            let errorObject = setErrorFields(
                'code',
                Helping.getMessageString(EMPTY, 'Code')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.status != null && state.status.length < 1) {
            let errorObject = setErrorFields(
                'status',
                Helping.getMessageString(EMPTY, 'Status')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.prefix != null && state.prefix.length < 1) {
            let errorObject = setErrorFields(
                'prefix',
                Helping.getMessageString(EMPTY, 'Prefix')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }

        if (state.backgroundImage != null && state.backgroundImage.length < 1) {
            let errorObject = setErrorFields(
                'backgroundImage',
                Helping.getMessageString(EMPTY, 'Background Image')
            );
            this.setState({ ...errorObject });
            formHasError = true;
        }
        return formHasError;
    };

    checkSectionEmptyFields = () => {
        let { currentSection } = this.state,
            formHasError = false,
            errors = {};

        if (!currentSection.title || currentSection.title.length < 1) {
            let errorObject = setErrorFields(
                'title',
                Helping.getMessageString(EMPTY, 'Title')
            );
            errors = { ...errors, ...errorObject };
            formHasError = true;
        }

        if (!currentSection.heading || currentSection.heading.length < 1) {
            let errorObject = setErrorFields(
                'heading',
                Helping.getMessageString(EMPTY, 'Heading')
            );
            errors = { ...errors, ...errorObject };
            formHasError = true;
        }

        if (!currentSection.type || currentSection.type.length < 1) {
            let errorObject = setErrorFields(
                'type',
                Helping.getMessageString(EMPTY, 'Type')
            );
            errors = { ...errors, ...errorObject };
            formHasError = true;
        }

        // if (!currentSection.link || currentSection.link.length < 1) {

        //     if (currentSection.buttonTitle || currentSection.buttonTitle.length > 1) {
        //         let errorObject = setErrorFields(
        //             'link',
        //             'Link is mandatory in case of Button Title'
        //         );
        //         errors = { ...errors, ...errorObject };
        //         formHasError = true;
        //     }
        //     else {
        //         let errorObject = clearErrorFields('link');
        //         errors = { ...errors, ...errorObject };
        //     }
        // }

        // if (!currentSection.defaultBtnLink || currentSection.defaultBtnLink.length < 1) {
        //     if (currentSection.defaultBtnTitle || currentSection.defaultBtnTitle.length > 1) {
        //         let errorObject = setErrorFields(
        //             'defaultBtnLink',
        //             'Link is mandatory in case of Button Title'
        //         );
        //         errors = { ...errors, ...errorObject };
        //         formHasError = true;
        //     }
        //     else {
        //         let errorObject = clearErrorFields('defaultBtnLink');
        //         errors = { ...errors, ...errorObject };
        //     }
        // }

        // if (!currentSection.content || currentSection.content.length < 1) {
        //     let errorObject = setErrorFields(
        //         'content',
        //         Helping.getMessageString(EMPTY, 'Content')
        //     );
        //     errors = { ...errors, ...errorObject };
        //     formHasError = true;
        // }

        // if (!currentSection.image || currentSection.image.length < 1) {
        //     let errorObject = setErrorFields(
        //         'image',
        //         Helping.getMessageString(EMPTY, 'Image')
        //     );
        //     errors = {...errors, ...errorObject};
        //     formHasError = true;
        // }

        if (Number(currentSection.orderSequence) < 1) {
            let errorObject = setErrorFields(
                'orderSequence',
                "Sequence Order should be greater than 0"
            );
            errors = { ...errors, ...errorObject };
            formHasError = true;
        }

        this.setState({
            currentSection: { ...currentSection, ...errors }
        });
        return formHasError;
    };

    onPageUpdate(event) {
        event.preventDefault();

        let $this = this;
        let formHasError = this.checkPageEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: "update-page",
            pageId: this.state.page_id,
            menuTitle: this.state.title,
            menuCode: this.state.code,
            isLive: this.state.is_live,
            status: this.state.status,
            prefix: this.state.prefix,
            backgroundImage: this.state.backgroundImage
        };

        Service.postCall(API_URL.ADMIN_API + GET_CMS_PAGE, data)
            .then((response) => {
                let page = response.data.payload;
                this.props.update(page);

                $this.setState({
                    page: page,
                    title: page.title,
                    code: page.code,
                    is_live: page.isLive,
                    status: page.status,
                    prefix: page.prefix,
                    backgroundImage: page.backgroundImage,
                    error_message: Helping.getMessageString(UPDATE, 'Page'),
                    error_type: 'success',
                    btnIsDisable: false
                },
                    () => { this.closeModal(); this.scrollToTop(); })
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsDisable: false,
                        },
                        () => { this.closeModal(); this.scrollToTop(); }
                    );
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, 'updating page'),
                },
                    () => { this.closeModal(); this.scrollToTop(); }
                );
            });
    }

    onSectionUpdate(event) {
        event.preventDefault();

        let $this = this,
            section = this.state.currentSection,
            formHasError = this.checkSectionEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            "action": "update-section",
            "sectionId": section.id,
            "title": section.title,
            "heading": section.heading,
            "content": section.content,
            "image": section.image,
            "isActive": section.isActive,
            "isLoop": section.type === 'CARD' ? section.isLoop : false,
            "type": section.type,
            "orderSequence": section.orderSequence ? Number(section.orderSequence) : 0,
            "logoUrl": section.logoUrl,
            "buttonTitle": section.buttonTitle,
            "link": section.buttonTitle ? section.link : "",
            "defaultBtnTitle": section.defaultBtnTitle,
            "defaultBtnLink": section.defaultBtnTitle ? section.defaultBtnLink : "",
            "mobileImage": section.mobileImage,
            "pageId": this.state.page_id
        };

        Service.postCall(API_URL.ADMIN_API + GET_CMS_PAGE, data)
            .then((response) => {
                $this.setState({
                    sections: response.data.payload.rows,
                    currentSection: {},
                    error_message: Helping.getMessageString(UPDATE, 'Section'),
                    error_type: 'success',
                    btnIsDisable: false
                },
                    () => { this.closeModal(); this.scrollToTop(); })
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            currentSection: {},
                            btnIsDisable: false,
                        },
                        () => { this.closeModal(); this.scrollToTop(); }
                    );
                }
                return this.setState({
                    isLoading: false,
                    currentSection: {},
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, 'updating section'),
                },
                    () => { this.closeModal(); this.scrollToTop(); }
                );
            });
    }

    onSectionCreate(event) {
        event.preventDefault();

        let $this = this,
            section = this.state.currentSection,
            formHasError = this.checkSectionEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            "action": "create-section",
            "title": section.title,
            "heading": section.heading,
            "content": section.content,
            "image": section.image,
            "isActive": section.isActive,
            "isLoop": section.type === 'CARD' ? section.isLoop : false,
            "type": section.type,
            "orderSequence": section.orderSequence ? Number(section.orderSequence) : 0,
            "logoUrl": section.logoUrl,
            "buttonTitle": section.buttonTitle,
            "link": section.buttonTitle ? section.link : "",
            "defaultBtnTitle": section.defaultBtnTitle,
            "defaultBtnLink": section.defaultBtnTitle ? section.defaultBtnLink : "",
            "mobileImage": section.mobileImage,
            "pageId": this.state.page_id
        };

        Service.postCall(API_URL.ADMIN_API + GET_CMS_PAGE, data)
            .then((response) => {
                let newSection = response.data.payload;
                let sections = this.state.sections;
                sections.push(newSection);

                $this.setState({
                    sections: sections,
                    currentSection: {},
                    error_message: Helping.getMessageString(CREATE, 'Section'),
                    error_type: 'success',
                    btnIsDisable: false
                },
                    () => { this.closeModal(); this.scrollToTop(); })
            })
            .catch((error) => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return $this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            currentSection: {},
                            btnIsDisable: false,
                        },
                        () => { this.closeModal(); this.scrollToTop(); }
                    );
                }
                return this.setState({
                    isLoading: false,
                    currentSection: {},
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, 'creating section'),
                },
                    () => { this.closeModal(); this.scrollToTop(); }
                );
            });
    }

    deleteSection() {
        this.setState({
            btnIsEnable: true
        });
        let self = this,
            data = {
                "action": "delete-section",
                "id": self.state.section_id,
            };

        Service.postCall(API_URL.ADMIN_API + GET_CMS_PAGE, data)
            .then(response => {
                let updatedSections = Helping.removeItem(self.state.sections, self.state.section_id);

                self.setState({
                    sections: updatedSections,
                    error_message: Helping.getMessageString(DELETE, 'Page Section'),
                    error_type: 'success',
                    btnIsEnable: false
                }, () => { this.closeModal(); this.scrollToTop(); });

            }).catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error);
                    return self.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        btnIsEnable: false
                    }, () => { this.closeModal(); this.scrollToTop(); });
                }
                return this.setState({
                    btnIsEnable: false,
                    ...Helping.setNetworkRequestError(error, "page section deletion")
                }, () => { this.closeModal(); this.scrollToTop(); })
            });
    }

    render() {
        const { page, sections, currentSection } = this.state;

        return (
            <>
                <Modal msg="page section" onDelete={this.deleteSection} btnIsEnable={this.state.btnIsEnable} />

                <div class="content user-view">
                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }
                    {page ? (
                        <>
                            <div class="top-header">
                                <div class="header-title">
                                    <h2 class="title">{page.menuTitle}</h2>
                                    <span class="title-caption">{page.status}</span>
                                </div>
                                <div class="header-btn">
                                    <button class="custom-btn dark-btn icon-btn sm-btn" onClick={() => this.props.history.goBack()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                            <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                                <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                                    <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                    <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                </g>
                                            </g>
                                        </svg>
                                        <span class="txt-btn">Back</span>
                                    </button>
                                </div>
                            </div>
                            <div class="main-content  view-page-content">
                                <div class="view-tabs double-tabs">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" data-toggle="tab" href="#cmsInfo" role="tab">
                                                <svg id="info" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path id="Path_394" data-name="Path 394" d="M11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Zm0,1.8A7.2,7.2,0,1,1,3.8,11,7.2,7.2,0,0,1,11,3.8Z" transform="translate(-2 -2)"></path><g id="info-2" data-name="info" transform="translate(-444 -18)"><rect id="Rectangle_277" data-name="Rectangle 277" width="1.5" height="6" rx="0.75" transform="translate(452.5 25)"></rect><rect id="Rectangle_278" data-name="Rectangle 278" width="1.5" height="1.5" rx="0.75" transform="translate(452.5 22.5)"></rect></g></svg>
                                                <span class="tab-text">Page Info</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" data-toggle="tab" href="#cmsSection" role="tab">
                                                <svg id="section" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                    <path id="Rectangle_296" data-name="Rectangle 296" d="M4,2A2,2,0,0,0,2,4V16a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H4M4,0H16a4,4,0,0,1,4,4V16a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z" />
                                                    <path id="Rectangle_297" data-name="Rectangle 297" d="M0,0H20V2H0Z" transform="translate(0 9)" />
                                                    <path id="Rectangle_298" data-name="Rectangle 298" d="M0,0H11V2H0Z" transform="translate(13 9) rotate(90)" />
                                                </svg>
                                                <span class="tab-text">Sections</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="cmsInfo" role="tabpanel">
                                        <div class="row user-profile">
                                            <div class="col-sm-6 col-md-6 col-lg-4">
                                                <ul class="list-view">
                                                    <li>
                                                        <label for="">Title</label>
                                                        <span>{page.menuTitle}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Code</label>
                                                        <span>{page.menuCode}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Status</label>
                                                        <span>{page.status}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Live</label>
                                                        <span>{page.isLive ? "Yes" : "No"}</span>
                                                    </li>

                                                </ul>
                                            </div>
                                            <div class="col-sm-6 col-md-6 col-lg-8">
                                                <ul class="list-view">
                                                    <li>
                                                        <label for="">Prefix</label>
                                                        <span>{page.prefix}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Created at</label>
                                                        <span>{Helping.convertTimeToHumanReadableFormat(page.created_at)}</span>
                                                    </li>
                                                    <li>
                                                        <label for="">Updated At</label>
                                                        <span>{Helping.convertTimeToHumanReadableFormat(page.updated_at)}</span>
                                                    </li>
                                                </ul>

                                            </div>

                                            <div class="col-12">
                                                <ul class="list-view">
                                                    <li>
                                                        <label for="">Background Image</label>
                                                        <span class="link d-link">
                                                            <a class="link" href={page.backgroundImage}
                                                                target="_blank">
                                                                {page.backgroundImage}
                                                            </a>
                                                        </span>
                                                    </li>
                                                </ul>
                                                <div style={{ alignItems: 'center', float: 'right' }}>
                                                    <button class="custom-btn sm-btn gradiant-btn"
                                                        data-target="#editPage" title="Edit Page" data-toggle="modal" data-placement="bottom">
                                                        Update Page
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane cms-tble" id="cmsSection" role="tabpanel">
                                        <button class="custom-btn gradiant-btn sm-btn"
                                            data-target="#editSection" data-toggle="modal" data-placement="bottom"
                                            onClick={(e) => this.handleAddSection(e)}>
                                            Add New Section
                                        </button>

                                        {sections.length > 0 ? (
                                            <div class="listing-tbl table-responsive mt-0">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">ID</th>
                                                            <th scope="col">Title</th>
                                                            <th class="text-center" scope="col">Image</th>
                                                            <th class="text-center" scope="col">Logo</th>
                                                            <th scope="col">Heading</th>
                                                            <th scope="col">Type</th>
                                                            <th scope="col">Active</th>
                                                            <th scope="col">Sequence Order</th>
                                                            <th scope="col">Created At</th>
                                                            <th scope="col">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {sections.map((section, i) => (
                                                            <tr key={i}>
                                                                <td scope="row">{section.id}</td>
                                                                <td>{section.title}</td>
                                                                <td>
                                                                    <div class="sectionCoverImg">
                                                                        <img src={section.image} alt="" class="img-fluid" />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="sectionCoverImg">
                                                                        {section.logoUrl &&
                                                                            <img src={section.logoUrl} alt="" class="img-fluid" />
                                                                        }
                                                                    </div>
                                                                </td>
                                                                <td>{section.heading}</td>
                                                                <td>{section.type}</td>
                                                                <td class={`text-center ${section.isActive ? 'yes' : 'no'}`}>{section.isActive ? "Yes" : "No"}</td>
                                                                <td class="text-center">{section.orderSequence}</td>
                                                                <td>
                                                                    <div class=" ">
                                                                        {Helping.convertTimeToHumanReadableFormat(
                                                                            section.created_at
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div class="action-links">
                                                                        <Link to={CMS_SECTION_DETAIL + section.id} className="icon view" title="View Detail">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17.5 13.5">
                                                                                <g id="Show" transform="translate(0.75 0.75)">
                                                                                    <path id="Stroke_1" data-name="Stroke 1" d="M5.469,2.6A2.669,2.669,0,0,1,2.734,5.2,2.668,2.668,0,0,1,0,2.6,2.668,2.668,0,0,1,2.734,0,2.669,2.669,0,0,1,5.469,2.6Z" transform="translate(5.266 3.402)" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                                    <path id="Stroke_3" data-name="Stroke 3" d="M8,12c3.293,0,6.306-2.25,8-6-1.7-3.75-4.708-6-8-6H8C4.708,0,1.7,2.25,0,6c1.7,3.75,4.708,6,8,6Z" fill="none" stroke="#00EC93" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                                                </g>
                                                                            </svg>
                                                                        </Link>

                                                                        <button type="button" class="icon edit"
                                                                            data-target="#editSection" title="Edit Section" data-toggle="modal" data-placement="bottom"
                                                                            onClick={(e) => this.openEditModal(e, section)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                                <path id="edit" d="M17,2a1.02,1.02,0,0,0-.719.281l-2,2-8,8A1.02,1.02,0,0,0,6,13v4a1,1,0,0,0,1,1h4a1.02,1.02,0,0,0,.719-.281l8-8,2-2A1.02,1.02,0,0,0,22,7a4.944,4.944,0,0,0-1.281-3.687A4.849,4.849,0,0,0,17,2Zm.375,2.063a2.753,2.753,0,0,1,1.906.625,2.92,2.92,0,0,1,.656,1.937L19,7.563,16.437,5ZM15,6.438,17.562,9l-7,7H8V13.438ZM10,4a1,1,0,0,1,0,2H6A2,2,0,0,0,4,8V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V14a1,1,0,0,1,2,0v4a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V8A4,4,0,0,1,6,4Z" transform="translate(-2 -2)" />
                                                                            </svg>
                                                                        </button>

                                                                        <button
                                                                            type='button'
                                                                            class="icon delete"
                                                                            data-toggle="modal" data-target="#exampleDeleteModal"
                                                                            onClick={(e) => this.openConfirmationModal(e, section)}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                                                                <path id="delete" d="M11.073,11.953V16.93a1,1,0,0,1-2,0V11.953a1,1,0,0,1,2,0Zm3-.995a1,1,0,0,0-1,.995V16.93a1,1,0,0,0,2,0V11.953A1,1,0,0,0,14.073,10.958Zm-8-.032a1,1,0,0,0-1,1v6a3.959,3.959,0,0,0,3.969,3.95l6.031.031a3.955,3.955,0,0,0,3.969-3.95v-6a1,1,0,0,0-2,0v6a1.964,1.964,0,0,1-1.969,1.96l-6.031-.032a1.96,1.96,0,0,1-1.969-1.959v-6A1,1,0,0,0,6.073,10.926Zm15-5.07V7.972a1,1,0,0,1-1,.995h-16a1,1,0,0,1-1-.995v-1.9A3.972,3.972,0,0,1,7.011,2.093L17.1,1.906A3.959,3.959,0,0,1,21.073,5.856ZM7.042,4.084a1.989,1.989,0,0,0-1.969,1.99v.9h14V5.856A1.95,1.95,0,0,0,17.135,3.9Z" transform="translate(-3.073 -1.906)" />
                                                                            </svg>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className='table-responsive'>
                                                <Notification
                                                    type='danger'
                                                    message={Helping.getMessageString(
                                                        NOT_FOUND,
                                                        'Sections '
                                                    )}
                                                    callback={this.removeNetworkError}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </>
                    ) : (
                        <div className='table-responsive'>
                            <Notification
                                type='danger'
                                message={Helping.getMessageString(
                                    NOT_FOUND,
                                    'CMS Page '
                                )}
                                callback={this.removeNetworkError}
                            />
                        </div>
                    )}

                    { /* Update Page */}
                    <div class="actionModal modal fade cms-page-modal" id="editPage" tabindex="-1" role="dialog" aria-labelledby="editPage" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="">Update Page Info</h5>
                                </div>

                                <div class="modal-body">
                                    <div class="form-group">
                                        <label for="pageTitle">Title</label>
                                        <input type="text" name="title" value={this.state.title} class={`form-control ${this.state.error_title_message ? 'error-input' : ''}`} id="pageTitle" onChange={(e) => this.handleChange(e)} />
                                        <span className="error-msg">{this.state.error_title_message}</span>
                                    </div>
                                    <div class="form-group">
                                        <label for="pageCode">Code</label>
                                        <input type="text" value={this.state.code} name="code" class={`form-control ${this.state.error_code_message ? 'error-input' : ''}`} id="pageCode" onChange={(e) => this.handleChange(e)} />
                                        <span className="error-msg">{this.state.error_code_message}</span>
                                    </div>
                                    <div class="form-group">
                                        <label for="status">Status</label>
                                        <select class={`form-select ${this.state.error_status_message ? 'error-input' : ''}`} name="status" aria-label="" id="status" value={this.state.status} onChange={(e) => this.handleChange(e)}>
                                            <option value='PUBLISHED'>Published</option>
                                            <option value='UNPUBLISHED'>Unpublished</option>
                                        </select>
                                        <span className="error-msg">{this.state.error_status_message}</span>
                                    </div>
                                    <div class="form-group">
                                        <label for="pagePrefix">Prefix</label>
                                        <input type="text" value={this.state.prefix} name="prefix" class={`form-control ${this.state.error_prefix_message ? 'error-input' : ''}`} id="pagePrefix" onChange={(e) => this.handleChange(e)} />
                                        <span className="error-msg">{this.state.error_prefix_message}</span>
                                    </div>
                                    <div class="userAccess">
                                        <label class="switch-label">Live: </label>
                                        <div class="form-switch">
                                            <input type="checkbox" class="check-form-input" id="live" checked={this.state.is_live} onChange={(e) => this.setState({ is_live: e.target.checked })} />
                                            <label for="live"></label>
                                        </div>
                                    </div>
                                    <div class='form-group'>
                                        <label for="">Background Image</label>

                                        <div class={`ImgField ${this.state.error_backgroundImage_message ? 'error-input' : ''}`}>
                                            {this.state.backgroundImage && (
                                                <div className="img-holder">
                                                    <span class="remove-img" title="Remove Background" onClick={() => this.removePageImage('backgroundImage', 'backgroundImage')}>&times;</span>
                                                    <img src={this.state.backgroundImage} />
                                                </div>
                                            )}
                                            <label class="imgFieldArea" for="backgroundImage">

                                                {!this.state.backgroundImage &&
                                                    <span class="icon fileImg">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                            <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                        </svg>
                                                    </span>
                                                }
                                                Click or drag and drop Image here
                                            </label>
                                            <input type="file" name="backgroundImage" id="backgroundImage" class="imgFieldInput" onChange={(e) => this.handleImageUpload(e)} />
                                        </div>
                                        <span className="error-msg">{this.state.error_backgroundImage_message}</span>

                                        {this.state.backgroundImagePercent > 0 && (
                                            <Progress percent={this.state.backgroundImagePercent} />
                                        )}
                                        <a class="link mt-2" href={this.state.backgroundImage} target="_blank">{this.state.backgroundImage} </a>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>

                                    {this.state.btnIsDisable ?
                                        <LoadingButton class_name={"sm-btn"} />
                                        :
                                        <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.onPageUpdate}>{this.state.btnIsDisable ? "Loading..." : "Update"}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ----- Update Section ----- */}
                    <div class="actionModal modal fade cms-page-modal" id="editSection" tabindex="-1" role="dialog" aria-labelledby="editSection" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="">{this.state.modalTitle}</h5>
                                </div>
                                <div class="row modal-body">
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="sectionTitle">Title</label>
                                            <input type="text" name="title" class={`form-control ${currentSection.error_title_message ? 'error-input' : ''}`} id="sectionTitle" value={currentSection.title} onChange={(e) => this.handleSectionValueChange(e, 'string')} />
                                            <span className="error-msg">{currentSection.error_title_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="sectionorder">Sequence Order</label>
                                            <input type="number" name="orderSequence" class={`form-control ${currentSection.error_orderSequence_message ? 'error-input' : ''}`} id="sectionorder" value={currentSection.orderSequence} onChange={(e) => this.handleSectionValueChange(e, 'number')} />
                                            <span className="error-msg">{currentSection.error_orderSequence_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="sectionDefaultBtnTitle">Default Button Title <small>(for logged out users)</small></label>
                                            <input type="text" name="defaultBtnTitle" class={`form-control ${currentSection.error_defaultBtnTitle_message ? 'error-input' : ''}`} id="sectionDefaultBtnTitle" value={currentSection.defaultBtnTitle} onChange={(e) => this.handleSectionValueChange(e, 'string')} />
                                            <span className="error-msg">{currentSection.error_defaultBtnTitle_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="sectionDefaultBtnLink">Default Button Link <small>(for logged out users)</small></label>
                                            <input type="text" name="defaultBtnLink" disabled={!currentSection.defaultBtnTitle} class={`form-control ${currentSection.error_defaultBtnLink_message ? 'error-input' : ''}`} id="sectionDefaultBtnLink" value={currentSection.defaultBtnLink} onChange={(e) => this.handleSectionValueChange(e, 'string')} />
                                            <span className="error-msg">{currentSection.error_defaultBtnLink_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="sectionButtonTitle">Button Title <small>(for logged in users)</small></label>
                                            <input type="text" name="buttonTitle" class={`form-control ${currentSection.error_buttonTitle_message ? 'error-input' : ''}`} id="sectionButtonTitle" value={currentSection.buttonTitle} onChange={(e) => this.handleSectionValueChange(e, 'string')} />
                                            <span className="error-msg">{currentSection.error_buttonTitle_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="sectionLink">Button Link <small>(for logged in users)</small></label>
                                            <input type="text" name="link" disabled={!currentSection.buttonTitle} class={`form-control ${currentSection.error_link_message ? 'error-input' : ''}`} id="sectionLink" value={currentSection.link} onChange={(e) => this.handleSectionValueChange(e, 'string')} />
                                            <span className="error-msg">{currentSection.error_link_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label for="sectionType">Type</label>
                                            <select class={`form-select ${currentSection.error_type_message ? 'error-input' : ''}`} name="type" aria-label="" id="sectionType" value={currentSection.type} onChange={(e) => this.handleSectionValueChange(e, 'string')} >
                                                <option value=''>Select Type...</option>
                                                <option value='FEATURED'>FEATURED</option>
                                                <option value='BOTTOM'>BOTTOM</option>
                                                <option value='INFO'>INFO</option>
                                                <option value='CARD'>CARD</option>
                                            </select>
                                            <span className="error-msg">{currentSection.error_type_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        {currentSection.type === 'CARD' && (
                                            <div class="userAccess cardLoopSwitch">
                                                <label class="switch-label">Loop: </label>
                                                <div class="form-switch">
                                                    <input type="checkbox" class="check-form-input" id="loop" name="isLoop" checked={currentSection.isLoop} onChange={(e) => this.handleSectionValueChange(e, 'switch')} />
                                                    <label for="loop"></label>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class='form-group'>
                                            <label for="">Section Image</label>

                                            <div class={`ImgField ${currentSection.error_image_message ? 'error-input' : ''}`}>
                                                {currentSection.image && (
                                                    <div className="img-holder">
                                                        <span class="remove-img" title="Remove Section Image" onClick={() => this.removeSectionImage('image', 'sectionFile')}>&times;</span>
                                                        <img src={currentSection.image} />
                                                    </div>
                                                )}
                                                <label class="imgFieldArea" for="sectionFile">

                                                    {!currentSection.image &&
                                                        <span class="icon fileImg">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                            </svg>
                                                        </span>
                                                    }
                                                    Click or drag and drop Image here
                                                </label>
                                                <input type="file" name="image" id="sectionFile" class="imgFieldInput" onChange={(e) => this.handleFileUpload(e)} />
                                            </div>
                                            <span className="error-msg">{currentSection.error_image_message}</span>

                                            {currentSection.imagePercent > 0 && (
                                                <Progress percent={currentSection.imagePercent} />
                                            )}
                                            <a class="link mt-2" href={currentSection.image} target="_blank">{currentSection.image} </a>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class='form-group'>
                                            <label for="">Mobile Image</label>

                                            <div class={`ImgField ${currentSection.error_mobileImage_message ? 'error-input' : ''}`}>
                                                {currentSection.mobileImage && (
                                                    <div className="img-holder">
                                                        <span class="remove-img" title="Remove Mobile Image" onClick={() => this.removeSectionImage('mobileImage', 'mobileImage')}>&times;</span>
                                                        <img src={currentSection.mobileImage} />
                                                    </div>
                                                )}

                                                <label class="imgFieldArea" for="mobileImage">

                                                    {!currentSection.mobileImage &&
                                                        <span class="icon fileImg">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                            </svg>
                                                        </span>
                                                    }
                                                    Click or drag and drop Image here
                                                </label>
                                                <input type="file" name="mobileImage" id="mobileImage" class="imgFieldInput" onChange={(e) => this.handleFileUpload(e)} />
                                            </div>
                                            <span className="error-msg">{currentSection.error_mobileImage_message}</span>

                                            {currentSection.mobileImagePercent > 0 && (
                                                <Progress percent={currentSection.mobileImagePercent} />
                                            )}
                                            <a class="link mt-2" href={currentSection.mobileImage} target="_blank">{currentSection.mobileImage} </a>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class='form-group'>
                                            <label for="">Section Logo</label>

                                            <div class={`ImgField ${currentSection.error_logoUrl_message ? 'error-input' : ''}`}>
                                                {currentSection.logoUrl && (
                                                    <div className="img-holder">
                                                        <span class="remove-img" title="Remove Section Logo" onClick={() => this.removeSectionImage('logoUrl', 'sectionLogo')}>&times;</span>
                                                        <img src={currentSection.logoUrl} />
                                                    </div>
                                                )}
                                                <label class="imgFieldArea" for="sectionLogo">

                                                    {!currentSection.logoUrl &&
                                                        <span class="icon fileImg">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                                <path id="images" d="M6,2A4,4,0,0,0,2,6V18a4,4,0,0,0,4,4H18a4,4,0,0,0,4-4V6a4,4,0,0,0-4-4ZM6,4H18a2,2,0,0,1,2,2v8.737A4.142,4.142,0,0,0,17,13c-1.293,0-2.448.921-3.563,2.406-.054.072-.071.118-.124.191-.236-.689-.5-1.353-.782-2C11.282,10.737,9.876,9,8,9c-1.632,0-2.919,1.38-3.991,3.447L4,6A2,2,0,0,1,6,4Zm2,7c.749,0,1.781,1.263,2.719,3.406a26.167,26.167,0,0,1,.968,2.656c.1.318.331,1.133.344,1.188a1.006,1.006,0,0,0,1.875.188c.054-.107.16-.3.313-.563a13.537,13.537,0,0,1,.843-1.281C15.823,15.579,16.543,15,17,15s1.177.579,1.937,1.594a14.039,14.039,0,0,1,1.043,1.638A1.978,1.978,0,0,1,18,20H6a1.94,1.94,0,0,1-1.406-.594,1.984,1.984,0,0,1-.563-1.344c.063-.224.2-.733.281-1a26.414,26.414,0,0,1,.969-2.656C6.219,12.263,7.251,11,8,11Zm7-3a1,1,0,1,1,1,1A1,1,0,0,1,15,8Z" transform="translate(-2 -2)" />
                                                            </svg>
                                                        </span>
                                                    }
                                                    Click or drag and drop Image here
                                                </label>
                                                <input type="file" name="logoUrl" id="sectionLogo" class="imgFieldInput" onChange={(e) => this.handleFileUpload(e)} />
                                            </div>
                                            <span className="error-msg">{currentSection.error_logoUrl_message}</span>

                                            {currentSection.logoUrlPercent > 0 && (
                                                <Progress percent={currentSection.logoUrlPercent} />
                                            )}
                                            <a class="link mt-2" href={currentSection.logoUrl} target="_blank">{currentSection.logoUrl} </a>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="userAccess">
                                            <label class="switch-label">Active: </label>
                                            <div class="form-switch">
                                                <input type="checkbox" class="check-form-input" id="active" name="isActive" checked={currentSection.isActive} onChange={(e) => this.handleSectionValueChange(e, 'switch')} />
                                                <label for="active"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label for="sectionHeading">Heading</label>
                                            <Editor initialValue={currentSection.heading} id="sectionHeading" name="heading" classes={`form-control ${currentSection.error_heading_message ? "error-input" : ""}`} handleChange={(e) => this.handleSectionValueChange(e, 'string')} />
                                            <span className="error-msg">{currentSection.error_heading_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label for="sectionContent">Content</label>
                                            <Editor initialValue={currentSection.content} id="sectionContent" name="content" classes={`form-control ${currentSection.error_content_message ? "error-input" : ""}`} handleChange={(e) => this.handleSectionValueChange(e, 'string')} />
                                            <span className="error-msg">{currentSection.error_content_message}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                    {this.state.btnIsDisable ?
                                        <LoadingButton class_name={"sm-btn"} />
                                        :
                                        this.state.section_id ?
                                            <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.onSectionUpdate}>{this.state.btnIsDisable ? "Loading..." : this.state.btnTitle}</button>
                                            :
                                            <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.onSectionCreate}>{this.state.btnIsDisable ? "Loading..." : this.state.btnTitle}</button>
                                    }
                                </div>
                            </div >
                        </div >
                    </div >
                </div>
            </>
        );
    }
}

const mapStateToProps = state => ({
    profile: state.profile
})

const mapDispatchToProps = {
    addCurrentRoute,
    update
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail);